import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import {WingBlank, WhiteSpace} from "antd-mobile";


class Support extends Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <WingBlank>
                <WhiteSpace />

            </WingBlank>
        )
    }
}

export default (withTranslation())(Support);